import { P } from 'components'
import BreadCrumbs from 'components/breadcrumbs'
import CustomButton from 'components/Buttons/CustomButton'
import PMBPagination from 'components/PMBPagination'
import PMBProgressBarExportFile from 'components/PMBProgressBarExportFile'
import { TableComponent as DataTable } from 'components/TableComponent'
import { useEffect, useRef, useState } from 'react'
import { ChevronDown, Download, Search, X } from 'react-feather'
import { Card, CardBody, Input, InputGroup, InputGroupText } from 'reactstrap'
import { formatDatePMB } from 'utils/formatDate'
import {
  useFetchProcessingReportsQuery,
  useLazyFetchProcessingReportsQuery,
} from './processReportApiSlice'
import { handleDownloadExcel } from './downloadReportProcess'
import LihatDetail from 'components/Icons/LihatDetail'
import { useNavigate } from 'react-router-dom'
import { URL_DETAIL_PROCESS } from 'utils/pathUrl'

export default function ReportProcess() {
  const navigate = useNavigate()
  const [page, setPage] = useState(0)
  const [size, setSize] = useState(10)
  const [sortby, setSortby] = useState('createdAt')
  const [sortdir, setSortdir] = useState('DESC')
  const [search, setSearch] = useState('')
  const [searchInput, setSearchInput] = useState('')
  const [isDownload, setIsDownload] = useState(false)
  const [firstRows, setFirstRows] = useState(0)
  const [totalRows, setTotalRows] = useState(0)
  const searchTimeoutRef = useRef()

  const [triggerFetchProcessingReports] = useLazyFetchProcessingReportsQuery()

  const { isLoading, isFetching, data } = useFetchProcessingReportsQuery({
    page,
    size,
    sortby,
    sortdir,
    s: search,
  })

  const handleSearchChange = (value) => {
    setSearchInput(value)

    if (page !== 0) {
      setPage(0)
    }

    if (searchTimeoutRef.current) {
      clearTimeout(searchTimeoutRef.current)
    }

    searchTimeoutRef.current = setTimeout(() => {
      setSearch(value.trim())
    }, 600)
  }

  useEffect(() => {
    return () => {
      if (searchTimeoutRef.current) {
        clearTimeout(searchTimeoutRef.current)
      }
    }
  }, [])

  const formatPercentage = (value) => {
    const numeric = Number(value)
    if (!Number.isFinite(numeric)) {
      return '-'
    }
    return `${numeric.toFixed(2)}%`
  }

  const handleClearSearch = () => {
    setSearchInput('')
    setSearch('')
    if (page !== 0) {
      setPage(0)
    }
  }

  const handleSearchKeyPress = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault()
      if (searchTimeoutRef.current) {
        clearTimeout(searchTimeoutRef.current)
      }
      setSearch(searchInput.trim())
      if (page !== 0) {
        setPage(0)
      }
    }
  }

  const columns = [
    {
      name: 'Tanggal',
      selector: (row) => (
        <P size="small" testId={`process-table-row-${row.id}`}>
          {formatDatePMB(row.createdAt, row?.createdAt)}
        </P>
      ),
      sortable: true,
      sortBy: 'createdAt',
      minWidth: '150px',
      isFreeze: true,
      freezePosition: 'left',
    },
    {
      name: 'Nama Proses',
      selector: (row) => (
        <P
          size="small"
          style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}
        >
          {row.processingName}
        </P>
      ),
      sortable: false,
      minWidth: '150px',
      isFreeze: true,
      freezePosition: 'left',
    },
    {
      name: 'Barang',
      selector: (row) => {
        return <P size="small">{row.nameItems ?? ''}</P>
      },
      sortable: true,
      sortBy: 'id',
      minWidth: '150px',
    },
    {
      name: 'Lot ID',
      selector: (row) => (
        <P
          size="small"
          style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}
        >
          {row.lotCode}
        </P>
      ),
      sortable: true,
      sortBy: 'lotCode',
      minWidth: '150px',
    },
    {
      name: 'Project',
      right: true,
      selector: (row) => <P size="small">{row.projectLabel}</P>,
      sortable: true,
      sortBy: 'projectLabel',
      minWidth: '150px',
    },
    // {
    //   name: 'Jumlah',
    //   right: true,
    //   selector: (row) => <P size="small">{row?.totalAmount}</P>,
    //   sortable: false,
    //   minWidth: '150px',
    // },
    {
      name: 'Tipe Proses',
      selector: (row) => <P size="small">{row.processingType}</P>,
      sortable: false,
      minWidth: '150px',
    },
    {
      name: 'Dibuat oleh',
      selector: (row) => (
        <P
          size="small"
          style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}
        >
          {row.creatorName}
        </P>
      ),
      sortable: true,
      sortBy: 'creatorName',
      minWidth: '250px',
    },
    {
      name: 'Raw Conversion %',
      selector: (row) => (
        <P size="small">{formatPercentage(row?.rawConversion)}</P>
      ),
      sortable: false,
      minWidth: '150px',
    },
    {
      name: 'Benchmark %',
      selector: (row) => <P size="small">{formatPercentage(row?.benchmark)}</P>,
      sortable: false,
      minWidth: '150px',
    },
    {
      name: '',
      width: '100px',
      selector: (row) => (
        <>
          <div data-testid={`process-row-detail-${row?.id}`}>
            <LihatDetail
              onClick={() => {
                navigate(`${URL_DETAIL_PROCESS}?id=${row?.processUniqueId}`)
              }}
              id={row?.id}
            />
          </div>
        </>
      ),
      center: true,
      isFreeze: true,
      freezePosition: 'right',
    },
  ]

  // const expandColumns = [
  //   {
  //     name: 'Nama',
  //     selector: (row) => {
  //       return (
  //         <P
  //           size="small"
  //           style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}
  //         >
  //           {row.nameItem}
  //         </P>
  //       )
  //     },
  //     // sortable: true,
  //     sortBy: 'nameItem',
  //   },
  //   {
  //     name: 'Lot ID',
  //     selector: (row) => (
  //       <P
  //         size="small"
  //         style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}
  //       >
  //         {row.lotCode}
  //       </P>
  //     ),
  //     // sortable: true,
  //     sortBy: 'lotCode',
  //   },
  //   {
  //     name: 'Jumlah',
  //     right: true,
  //     selector: (row) => (
  //       <P
  //         size="small"
  //         style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}
  //       >{`${newFormatThousandSeparator(row.amount ?? 0)} ${row?.unit}`}</P>
  //     ),
  //     sortable: false,
  //   },
  // ]

  // const ExpandedComponent = ({ data }) => {
  //   const isMobile = window.innerWidth < 768
  //   const [open, setOpen] = useState('')

  //   const toggle = (id) => {
  //     setOpen((prev) => (prev === id ? '' : id))
  //   }

  //   if (isMobile) {
  //     return (
  //       <Collapse isOpen={true} toggle={toggle}>
  //         <div className="mt-3">
  //           {data?.rawMaterials && data.rawMaterials.length > 0 ? (
  //             <Accordion toggle={toggle} stayOpen open={open}>
  //               <AccordionItem>
  //                 <AccordionHeader targetId="1">
  //                   <P size="regular">
  //                     {open === '1'
  //                       ? 'Sembunyikan detail'
  //                       : 'Lihat selengkapnya'}
  //                   </P>
  //                 </AccordionHeader>
  //                 <AccordionBody accordionId="1">
  //                   {data.rawMaterials.map((material, index) => (
  //                     <div key={index} className="bg-white">
  //                       <div className="row g-2">
  //                         <div className="col-12">
  //                           <div className="d-flex justify-content-between align-items-start">
  //                             <div className="text-muted small">
  //                               <P size="regular">Nama</P>
  //                             </div>
  //                             <div
  //                               className="text-end"
  //                               style={{ maxWidth: '80%' }}
  //                             >
  //                               <P size="regular">{material.nameItem}</P>
  //                             </div>
  //                           </div>
  //                         </div>
  //                         <div className="col-12">
  //                           <div className="d-flex justify-content-between">
  //                             <div className="text-muted">
  //                               <P size="regular">Lot ID</P>
  //                             </div>
  //                             <div className="text-end">
  //                               <P size="regular">{material.lotCode}</P>
  //                             </div>
  //                           </div>
  //                         </div>
  //                         <div className="col-12 border-bottom pb-2 mb-2">
  //                           <div className="d-flex justify-content-between">
  //                             <div className="text-muted">
  //                               <P size="regular">Jumlah</P>
  //                             </div>
  //                             <div className="text-end">
  //                               <P size="regular">
  //                                 {newFormatThousandSeparator(
  //                                   material.amount ?? 0,
  //                                 )}{' '}
  //                                 {material?.unit}
  //                               </P>
  //                             </div>
  //                           </div>
  //                         </div>
  //                       </div>
  //                     </div>
  //                   ))}
  //                 </AccordionBody>
  //               </AccordionItem>
  //             </Accordion>
  //           ) : (
  //             <div className="text-center py-2 text-muted small">
  //               Tidak ada bahan baku
  //             </div>
  //           )}
  //         </div>
  //       </Collapse>
  //     )
  //   }

  //   return (
  //     <div className="p-3">
  //       <DataTable
  //         sortServer
  //         defaultSortFieldId={1}
  //         defaultSortAsc={false}
  //         sortIcon={<ChevronDown />}
  //         columns={expandColumns}
  //         data={data?.rawMaterials || []}
  //         progressPending={isFetching || isLoading}
  //       />
  //     </div>
  //   )
  // }

  return (
    <div className="w-100 px-3">
      <PMBProgressBarExportFile
        isDialogShow={isDownload}
        firstRows={firstRows}
        totalRows={totalRows}
        onCancel={() => setIsDownload(false)}
      />
      <div className="d-flex align-items-start gap-2 pt-3">
        <BreadCrumbs breadCrumbActive={'Laporan Proses'} />
      </div>
      <div className="d-flex flex-column gap-2 mb-2">
        <Card className="border-0 shadow-sm">
          <CardBody>
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h5 size="large">Laporan Proses</h5>
            </div>
            <DataTable
              sortServer
              defaultSortFieldId={1}
              defaultSortAsc={false}
              sortIcon={<ChevronDown />}
              onSort={(column, sortDirection) => {
                // Gunakan sortBy jika ada, fallback ke selector
                const sortField = column.sortBy || column.selector
                setSortby(sortField)
                setSortdir(sortDirection.toUpperCase())
              }}
              columns={columns}
              data={data?.items || []}
              progressPending={isFetching || isLoading}
              pagination
              paginationServer
              paginationComponent={(props) => (
                <PMBPagination
                  rowCount={data?.totalItems || 0}
                  currentPage={data?.currentPage || 0}
                  rowsPerPage={size ?? 10}
                  setCurrentPage={(e) => {
                    setPage(e)
                  }}
                  setRowsPerPage={(e) => {
                    setSize(e)
                    setPage(0)
                  }}
                  props={props}
                />
              )}
              // expandableRows
              // expandableRowsComponent={ExpandedComponent}
              subHeader={true}
              subHeaderComponent={
                <div className="container-fluid p-0">
                  <div className="d-flex justify-content-between align-items-end flex-wrap gap-2 mb-3">
                    <div
                      style={{ maxWidth: '346px' }}
                      className="w-100 w-md-auto"
                    >
                      <p className="mb-2">Cari</p>
                      <div className="d-flex">
                        <InputGroup style={{ borderColor: '#D0D5DD' }}>
                          <InputGroupText
                            style={{
                              backgroundColor: 'white',
                              borderRightColor: 'white',
                            }}
                          >
                            <Search color="#667085" size={16} />
                          </InputGroupText>
                          <Input
                            data-testid="process-search-input"
                            style={{
                              maxWidth: '100%',
                            }}
                            value={searchInput}
                            placeholder="Cari inventori..."
                            onChange={(e) => handleSearchChange(e.target.value)}
                            onKeyPress={handleSearchKeyPress}
                          />
                          {searchInput && (
                            <InputGroupText
                              data-testid="process-search-clear-button"
                              style={{
                                backgroundColor: 'white',
                                borderLeftColor: 'white',
                                cursor: 'pointer',
                              }}
                              onClick={handleClearSearch}
                            >
                              <X color="#667085" size={16} />
                            </InputGroupText>
                          )}
                        </InputGroup>
                      </div>
                    </div>
                    <div className="d-flex align-items-end">
                      <CustomButton
                        onClick={() =>
                          handleDownloadExcel(
                            data,
                            setIsDownload,
                            setFirstRows,
                            setTotalRows,
                            triggerFetchProcessingReports,
                            {
                              sortby,
                              sortdir,
                              s: search,
                            },
                          )
                        }
                        color="primary"
                        outline
                        disabled={
                          !data?.totalItems ||
                          data?.totalItems < 1 ||
                          isFetching ||
                          isLoading
                        }
                        testId="process-report-download-button"
                        className="d-flex align-items-center gap-2"
                      >
                        <Download size={15} /> Download
                      </CustomButton>
                    </div>
                  </div>
                </div>
              }
            />
          </CardBody>
        </Card>
      </div>
    </div>
  )
}
